export const spaceZero = "0rem";
export const space4xs = ".125rem"; // 2px
export const space3xs = ".25rem"; // 4px
export const space2xs = ".5rem"; // 8px
export const spaceXs = ".75rem"; // 12px
export const spaceSm = "1rem"; // 16px
export const spaceMd = "1.25rem"; // 20px
export const spaceLg = "1.5rem"; // 24px
export const spaceXl = "2rem"; // 32px
export const space2xl = "2.5rem"; // 40px
export const space3xl = "3rem"; // 48px
export const space4xl = "4rem"; // 64px
export const space5xl = "5rem"; // 80px
export const space6xl = "6rem"; // 96px
export const space7xl = "8rem"; // 128px
export const spaceBase = ".5rem"; // base unit of spacing .5rem (not for direct use)
export const borderRadiusBase = "2px"; // $br-base • 2px
export const borderRadiusXs = "2px"; // 2px
export const borderRadiusSm = "4px"; // 4px
export const borderRadiusMd = "8px"; // 8px
export const borderRadiusLg = "12px"; // 12px
export const borderRadiusXl = "16px"; // 16px
export const borderRadius2xl = "20px"; // 20px
export const borderRadius3xl = "24px"; // 24px
export const borderRadius4xl = "32px"; // 32px
export const boxShadowFocused = "0px 0px 3px 1px #fc5200"; // focused state box shadow
export const boxShadowError = "0px 0px 1px 1px #B71414"; // error field box shadow
export const boxShadowElevationNearest = "0px 2px 04px 0px rgba(0,0,0,0.1)";
export const boxShadowElevationNearer = "0px 02px 06px 0px rgba(0,0,0,0.11)";
export const boxShadowElevationNear = "0px 02px 06px 0px rgba(0,0,0,0.08)";
export const boxShadowElevationFar = "0px 03px 08px 0px rgba(0,0,0,0.12), 0px 03px 01px 0px rgba(0,0,0,0.04)";
export const boxShadowElevationFurther = "0px 02px 06px 0px rgba(0,0,0,0.2)";
export const boxShadowElevationFurthest = "0px .5px 4px 0px rgba(0,0,0,0.1), 0px 06px 012px 0px rgba(0,0,0,0.1)";
export const boxShadowElevationInvertedFurthest = "0px -8px 16px 0px rgba(0,0,0,0.08)";
export const backgroundPaperOutline = "0px 0px 0px 1px #e0e0e0";
export const backgroundPaperElevation1 = "0px 1px 8px 0px #00000014";
export const backgroundPaper2Outline = "0px 0px 0px 1px #e0e0e0";
export const backgroundPaper2Elevation1 = "0px 1px 8px 0px #00000014";
export const sizeBase = "1rem"; // 16px
export const size2xs = ".5rem"; // 8px
export const sizeXs = ".75rem"; // 12px
export const sizeSm = "1rem"; // 16px
export const sizeMd = "1.25rem"; // 20px
export const sizeLg = "1.5rem"; // 24px
export const sizeXl = "2rem"; // 32px
export const size2xl = "2.5rem"; // 40px
export const size3xl = "3rem"; // 48px
export const size4xl = "4rem"; // 64px
